import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useMemo } from 'react';
import { DisplayCostAppearance, textAppearances } from './displayCost.settings';

export const useDisplayCostHelper = (cost: number | string, appearance: DisplayCostAppearance) => {
	const t = useTranslation();

	const eur = t('general.eur');
	const month = t('general.month');

	const costText = useMemo(
		() =>
			`${cost} <currency>${eur.toUpperCase()}</currency><frequency>/${month}${
				appearance === 'secondarySolution' || appearance === 'promotionalMainSolution' ? '*' : ''
			}</frequency>`,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[appearance, cost]
	);

	return { costText, ...textAppearances[appearance] };
};
